import { useEffect, useState } from "react";

interface UseDebounceReturn<T> {
  debouncedValue: T;
  setIsSearching: React.Dispatch<React.SetStateAction<boolean>>;
  isSearching: boolean;
}

export function useDebounce<T>(value: T, delay: number): UseDebounceReturn<T> {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const [isSearching, setIsSearching] = useState<boolean>(false);

  useEffect(
    () => {
      // Update debounced value after delay
      setIsSearching(true);
      const handler = setTimeout(() => {
        setDebouncedValue(value);
        setIsSearching(false);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );

  return { debouncedValue, setIsSearching, isSearching };
}
